import styled from 'styled-components'

export const Container = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const FilterBox = styled.div`
  border-radius: ${(props) => props.theme.border.radius};
  border: 1px solid #eaecef;
  padding: 1rem;
  background: ${(props) => props.theme.color.neutral.white};
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const Title = styled.h1`
  font-size: ${(props) => props.theme.font.textsm};
  color: ${(props) => props.theme.color.neutral.gray};
  font-weight: 400;
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
`

export const InputContainer = styled.div`
  min-width: 20%;
  max-width: 30%;
`

export const ButtonContainer = styled.div`
  min-width: 20%;
  max-width: 30%;
`

export const CamerasBox = styled.div`
  border-radius: ${(props) => props.theme.border.radius};
  border: 1px solid #eaecef;
  padding: 1rem;
  background: ${(props) => props.theme.color.neutral.white};
  display: flex;
  flex-wrap: wrap;
`
